import React, {FC} from "react";
import './ShareBoost.css'
import {PiShareFat} from "react-icons/pi";
import {TfiBolt} from "react-icons/tfi";
import {useStateValue} from "../state-provider/StateProvider";
import {Pulsating} from "./Pulsating";
import {GridAreaContentLayout} from "./GridAreaContentLayout";
import {GridAreaContentLayoutButton} from "./GridAreaContentLayoutButton";

export const ShareBoost:FC<{
  shareButtonClicked: () => void,
}> = ({
  shareButtonClicked
}) => {

  const [ { shareJoinedCount, translations }] = useStateValue()

  return (
    <GridAreaContentLayout
      heading={(
        <>
          <div className={"share-boost-centered"}>
            <div className={"share-boost-line1"}>
              {translations['ShareBoostTitle'] || "Share the link"} <PiShareFat className={"icon-aligned-middle"} size={36} color={"#FFD51F"}/>
            </div>
          </div>
          <div className={"share-boost-centered"}>
            <div className={"share-boost-line2"}>
              {translations['ShareBoostSubtitle'] || "Increase your chance of winning"}
            </div>
          </div>
        </>
      )}
      footer={(
        <GridAreaContentLayoutButton onClick={shareButtonClicked} label={translations['ShareBoostButtonLabel'] || "Start sharing"} icon={<PiShareFat/>}/>
      )}
    >
      <div className={"share-boost-centered"}>
        <div className={"share-boost-line3"}>
          {translations['ShareBoostDescription'] || "Each new joined user doubles your chance!"}
        </div>
      </div>
      <div className={"share-boost-centered"}>
        <div className={"share-boost-line4"}>
          {translations['ShareBoostPointsLabel'] || "Gain points before the winner announcement."}
        </div>
      </div>
      <div className={"share-boost-centered"}>
        <div className={"share-boost-line5"}>
          <div>
            {translations['ShareBoostStatusLabel'] || "Your status"}
          </div>
          <Pulsating>
            <div className={"share-counter"}>
                    <span>
                      +{shareJoinedCount}
                    </span>
              <TfiBolt size={36} className={"icon-aligned-middle"} style={{ marginLeft: -5 }}/>
            </div>
          </Pulsating>
        </div>
      </div>
      <div style={{ margin: "32px "}}></div>
    </GridAreaContentLayout>
  )
}